import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import WeatherContext from '../../../context/WeatherContext';
import {
    OBJECT_SEARCH,
    OBJECT_TRACK_ANALYZER,
    OBJECT_TYPE_CLOUD_TRACK,
    OBJECT_TYPE_FAVORITE,
    OBJECT_TYPE_LOCAL_TRACK,
    OBJECT_TYPE_NAVIGATION_TRACK,
    OBJECT_TYPE_TRAVEL,
    OBJECT_TYPE_WEATHER,
    FAVORITES_URL_PARAM_FOLDER,
} from '../../../context/AppContext';
import TravelContext from '../../../context/TravelContext';
import { selectedForecastDetails } from '../../../menu/weather/Weather';
import { ROUTE_POINTS_START, ROUTE_POINTS_FINISH } from '../../../store/geoRouter/profileConstants';

export default function useMenuDots(ctx) {
    const wtx = useContext(WeatherContext);
    const ttx = useContext(TravelContext);
    const [menuDots, setMenuDots] = useState({});
    const [searchParams] = useSearchParams();

    function setActiveMenu(type, value) {
        setMenuDots((prev) => ({ ...prev, [type]: value }));
    }

    useEffect(() => {
        const hasOpenFolder = searchParams.get(FAVORITES_URL_PARAM_FOLDER) !== null;
        setActiveMenu(OBJECT_TYPE_FAVORITE, hasOpenFolder || ctx.selectedFavoriteObj);
    }, [searchParams, ctx.selectedFavoriteObj]);

    useEffect(() => {
        setActiveMenu(
            OBJECT_TYPE_CLOUD_TRACK,
            ctx.openGroups?.length > 0 || ctx.selectedCloudTrackObj || ctx.openVisibleMenu?.showTracks
        );
    }, [ctx.openGroups, ctx.selectedCloudTrackObj, ctx.openVisibleMenu?.showTracks]);

    useEffect(() => {
        if (!wtx?.weatherLayers || !wtx?.weatherType) {
            return;
        }
        const showDetails = selectedForecastDetails(wtx);
        const openLayers = wtx.weatherLayers[wtx.weatherType]?.some((l) => l.checked);

        setActiveMenu(OBJECT_TYPE_WEATHER, !isSameHour() || showDetails || openLayers);
    }, [wtx?.weatherDate, wtx?.weatherLayers, wtx?.weatherType]);

    useEffect(() => {
        const hasSearchResults = ttx.searchTravelRoutes && !ttx.searchTravelRoutes.clear;

        setActiveMenu(OBJECT_TYPE_TRAVEL, hasSearchResults || ttx.selectedTravelRoute);
    }, [ttx.searchTravelRoutes, ttx.selectedTravelRoute]);

    useEffect(() => {
        setActiveMenu(
            OBJECT_SEARCH,
            ctx.searchResult || ctx.exploreMenu || ctx.poiCatMenu || ctx.selectedPoiObj || ctx.selectedSearchObj
        );
    }, [ctx.searchResult, ctx.exploreMenu, ctx.poiCatMenu, ctx.selectedPoiObj, ctx.selectedSearchObj]);

    useEffect(() => {
        setActiveMenu(OBJECT_TRACK_ANALYZER, ctx.trackAnalyzer);
    }, [ctx.trackAnalyzer]);

    useEffect(() => {
        const startPoint = ctx.routeObject.getOption(ROUTE_POINTS_START);
        const finishPoint = ctx.routeObject.getOption(ROUTE_POINTS_FINISH);
        setActiveMenu(OBJECT_TYPE_NAVIGATION_TRACK, startPoint || finishPoint);
    }, [ctx.routeObject]);

    useEffect(() => {
        setActiveMenu(OBJECT_TYPE_LOCAL_TRACK, ctx.selectedLocalTrackObj);
    }, [ctx.selectedLocalTrackObj]);

    function isSameHour() {
        if (!wtx?.weatherDate) return true;
        const initial = new Date();
        const current = wtx.weatherDate;

        return (
            initial.getFullYear() === current.getFullYear() &&
            initial.getMonth() === current.getMonth() &&
            initial.getDate() === current.getDate() &&
            initial.getHours() === current.getHours()
        );
    }

    return menuDots;
}
